import React, { useState } from "react";
import moment from "moment";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import RecordModal from "../components/record/RecordModal";
import axios from "axios";
import { SingleDatePicker } from "react-dates";
import { AlertSwal } from "../components/CustomSwal";
import { FormattedMessage, useIntl } from "react-intl";

function Record(props) {
  const [startDate, setStartDate] = useState(moment().subtract(6, "days"));
  const [startDate_focus, setStartDate_focus] = useState(null);
  const [endDate, setEndDate] = useState(moment());
  const [endDate_focus, setEndDate_focus] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);

  const intl = useIntl();
  const sid = sessionStorage.getItem("sid");
  const authid = sessionStorage.getItem("authid");
  const config = props.config;

  const SchBookLogList = (page) => {
    props.setLoading(true);
    setSelectedTitle(intl.formatMessage({ id: "record.reservation_record" }));
    axios
      .get(config.API_URL + `/SchBookLogList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          stime: startDate.format("YYYYMMDD") + "000000",
          etime: endDate.format("YYYYMMDD") + "235959",
          page: page,
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            if (data.rows.length > 0) {
              let stateData = {
                class: "record_table_thead record_btn_1",
                thead: [],
                tbody: [],
                onPageChange: SchBookLogList,
                totalpage: data.totalpage,
                page: data.page,
              };
              stateData.thead = [
                intl.formatMessage({ id: "global._spacetype" }),
                intl.formatMessage({ id: "global.devicename" }),
                intl.formatMessage({ id: "record.status" }),
                intl.formatMessage({ id: "global.reader_name" }),
                intl.formatMessage({ id: "global.reservation_date" }),
                intl.formatMessage({ id: "global.reservation_time" }),
              ];
              for (let i = 0; i < data.rows.length; i++) {
                stateData.tbody.push([
                  intl.formatMessage({
                    id: `global.spacetype.${data.rows[i].spacetype}`,
                    defaultMessage: data.rows[i].spacetypename,
                  }),
                  data.rows[i].devicename,
                  intl.formatMessage({
                    id: `info.usestatus.${data.rows[i].status}`,
                    defaultMessage: data.rows[i].statusname,
                  }),
                  data.rows[i].username,
                  data.rows[i].bookdate,
                  data.rows[i].booktime,
                ]);
              }
              setData(stateData);
              setShow(true);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.no_data" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const SchBookLogDelList = (page) => {
    props.setLoading(true);
    setSelectedTitle(intl.formatMessage({ id: "record.deleted_record" }));
    axios
      .get(config.API_URL + `/SchBookLogDelList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          stime: startDate.format("YYYYMMDD") + "000000",
          etime: endDate.format("YYYYMMDD") + "235959",
          page: page,
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            if (data.rows.length > 0) {
              let stateData = {
                class: "record_table_thead record_btn_0",
                thead: [],
                tbody: [],
                onPageChange: SchBookLogDelList,
                totalpage: data.totalpage,
                page: data.page,
              };
              stateData.thead = [
                intl.formatMessage({ id: "global._spacetype" }),
                intl.formatMessage({ id: "global.devicename" }),
                intl.formatMessage({ id: "record.status" }),
                intl.formatMessage({ id: "global.reader_name" }),
                intl.formatMessage({ id: "global.reservation_date" }),
                intl.formatMessage({ id: "global.reservation_time" }),
              ];
              for (let i = 0; i < data.rows.length; i++) {
                stateData.tbody.push([
                  intl.formatMessage({
                    id: `global.spacetype.${data.rows[i].spacetype}`,
                    defaultMessage: data.rows[i].spacetypename,
                  }),
                  data.rows[i].devicename,
                  intl.formatMessage({
                    id: `info.usestatus.${data.rows[i].status}`,
                    defaultMessage: data.rows[i].statusname,
                  }),
                  data.rows[i].username,
                  data.rows[i].bookdate,
                  data.rows[i].booktime,
                ]);
              }
              setData(stateData);
              setShow(true);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.no_data" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const SchSpaceUseLogList = (page) => {
    props.setLoading(true);
    setSelectedTitle(intl.formatMessage({ id: "record.use_space_record" }));
    axios
      .get(config.API_URL + `/SchSpaceUseLogList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          stime: startDate.format("YYYYMMDD") + "000000",
          etime: endDate.format("YYYYMMDD") + "235959",
          page: page,
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            if (data.rows.length > 0) {
              let stateData = {
                class: "record_table_thead record_btn_2",
                thead: [],
                tbody: [],
                onPageChange: SchSpaceUseLogList,
                totalpage: data.totalpage,
                page: data.page,
              };
              stateData.thead = [
                intl.formatMessage({ id: "global._spacetype" }),
                intl.formatMessage({ id: "global.devicename" }),
                intl.formatMessage({ id: "record.status" }),
                intl.formatMessage({ id: "global.reader_name" }),
                intl.formatMessage({ id: "record.mdate" }),
              ];
              for (let i = 0; i < data.rows.length; i++) {
                stateData.tbody.push([
                  intl.formatMessage({
                    id: `global.spacetype.${data.rows[i].spacetype}`,
                    defaultMessage: data.rows[i].spacetypename,
                  }),
                  data.rows[i].devicename,
                  props.locale === "en"
                    ? data.rows[i].logstatusename
                    : data.rows[i].logstatusname,
                  data.rows[i].username,
                  data.rows[i].accesstime,
                ]);
              }
              setData(stateData);
              setShow(true);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.no_data" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const SchViolateLogList = (page) => {
    props.setLoading(true);
    setSelectedTitle(
      intl.formatMessage({ id: "record.violating_reservation_record" })
    );
    axios
      .get(config.API_URL + `/SchViolateLogList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          stime: startDate.format("YYYYMMDD") + "000000",
          etime: endDate.format("YYYYMMDD") + "235959",
          page: page,
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            if (data.rows.length > 0) {
              let stateData = {
                class: "record_table_thead record_btn_3",
                thead: [],
                tbody: [],
                onPageChange: SchViolateLogList,
                totalpage: data.totalpage,
                page: data.page,
                showAlert: true,
              };
              stateData.thead = [
                intl.formatMessage({ id: "global._spacetype" }),
                intl.formatMessage({ id: "global.devicename" }),
                intl.formatMessage({ id: "global.reader_name" }),
                intl.formatMessage({ id: "record.mdate" }),
              ];
              for (let i = 0; i < data.rows.length; i++) {
                stateData.tbody.push([
                  intl.formatMessage({
                    id: `global.spacetype.${data.rows[i].spacetype}`,
                    defaultMessage: data.rows[i].spacetypename,
                  }),
                  data.rows[i].seatname === ""
                    ? data.rows[i].spacename
                    : data.rows[i].seatname,
                  data.rows[i].username,
                  data.rows[i].mdate,
                ]);
              }
              setData(stateData);
              setShow(true);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.no_data" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const SchSuspendLogList = (page) => {
    props.setLoading(true);
    setSelectedTitle(intl.formatMessage({ id: "record.suspension_record" }));
    axios
      .get(config.API_URL + `/SchSuspendLogList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          stime: startDate.format("YYYYMMDD") + "000000",
          etime: endDate.format("YYYYMMDD") + "235959",
          page: page,
        },
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            if (data.rows.length > 0) {
              let stateData = {
                class: "record_table_thead record_btn_4",
                thead: [],
                tbody: [],
                onPageChange: SchSuspendLogList,
                totalpage: data.totalpage,
                page: data.page,
              };
              stateData.thead = [
                intl.formatMessage({ id: "global.reader_name" }),
                intl.formatMessage({ id: "record.card_no" }),
                intl.formatMessage({ id: "record.suspend_sdate" }),
                intl.formatMessage({ id: "record.suspend_edate" }),
                intl.formatMessage({ id: "record.mdate" }),
              ];
              for (let i = 0; i < data.rows.length; i++) {
                stateData.tbody.push([
                  data.rows[i].username,
                  data.rows[i].cardno,
                  data.rows[i].blacksdate,
                  data.rows[i].blackedate,
                  data.rows[i].mdate,
                ]);
              }
              setData(stateData);
              setShow(true);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.no_data" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    let i;
    let years = [];
    for (i = moment().year(); i >= moment().year() - 5; i--) {
      years.push(
        <option value={i} key={`year-${i}`}>
          {i}
        </option>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <select
            style={{ borderColor: "#e4e7e7" }}
            value={month.month()}
            onChange={(e) => onMonthSelect(month, e.target.value)}
          >
            {moment.months().map((label, value) => (
              <option value={value} key={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            style={{ borderColor: "#e4e7e7" }}
            value={month.year()}
            onChange={(e) => onYearSelect(month, e.target.value)}
          >
            {years}
          </select>
        </div>
      </div>
    );
  };

  return (
    <>
      <Form>
        <Form.Row>
          <Form.Group as={Col} className="mb-2">
            <Form.Label className="mb-0">
              <FormattedMessage id="record.start_date" />
            </Form.Label>
            <SingleDatePicker
              id="startDate"
              date={startDate}
              focused={startDate_focus}
              onDateChange={(e) => {
                setStartDate(e);
                if (e.isAfter(endDate, "days")) {
                  setEndDate(e);
                }
              }}
              onFocusChange={(e) => {
                setStartDate_focus(e.focused);
              }}
              renderMonthElement={renderMonthElement}
              isOutsideRange={(d) =>
                d.isAfter(moment()) && !d.isSame(moment(), "days")
              }
              displayFormat="YYYY/MM/DD"
              numberOfMonths={
                document.documentElement.clientWidth < 576 ? 1 : 2
              }
              block
              readOnly
              withPortal
            />
          </Form.Group>
          <Form.Group as={Col} className="mb-2 right-picker">
            <Form.Label className="mb-0">
              <FormattedMessage id="record.end_date" />
            </Form.Label>
            <SingleDatePicker
              id="endDate"
              date={endDate}
              focused={endDate_focus}
              onDateChange={(e) => {
                setEndDate(e);
                if (e.isBefore(startDate, "days")) {
                  setStartDate(e);
                }
              }}
              onFocusChange={(e) => {
                setEndDate_focus(e.focused);
              }}
              renderMonthElement={renderMonthElement}
              isOutsideRange={(d) =>
                d.isAfter(moment()) && !d.isSame(moment(), "days")
              }
              displayFormat="YYYY/MM/DD"
              numberOfMonths={
                document.documentElement.clientWidth < 576 ? 1 : 2
              }
              block
              readOnly
              withPortal
            />
          </Form.Group>
        </Form.Row>
      </Form>
      <button
        className="record_btn record_btn_0 w-100 pt-3 pb-3 mt-1 mb-1"
        onClick={() => SchBookLogDelList(1)}
      >
        <FormattedMessage id="record.deleted_record" />
      </button>
      <button
        className="record_btn record_btn_1 w-100 pt-3 pb-3 mt-1 mb-1"
        onClick={() => SchBookLogList(1)}
      >
        <FormattedMessage id="record.reservation_record" />
      </button>
      <button
        className="record_btn record_btn_2 w-100 pt-3 pb-3 mt-1 mb-1"
        onClick={() => SchSpaceUseLogList(1)}
      >
        <FormattedMessage id="record.use_space_record" />
      </button>
      <button
        className="record_btn record_btn_3 w-100 pt-3 pb-3 mt-1 mb-1"
        onClick={() => SchViolateLogList(1)}
      >
        <FormattedMessage id="record.violating_reservation_record" />
      </button>
      <button
        className="record_btn record_btn_4 w-100 pt-3 pb-3 mt-1 mb-1"
        onClick={() => SchSuspendLogList(1)}
      >
        <FormattedMessage id="record.suspension_record" />
      </button>
      {show ? (
        <RecordModal
          {...props}
          show={show}
          setShow={setShow}
          data={data}
          selectedTitle={selectedTitle}
        />
      ) : null}
    </>
  );
}

export default Record;
